import React from 'react'
import { Link } from 'react-router'

import { slugify } from '@devicebits/slugify'
import _ from 'lodash'

import TextHighlights from './TextWithHighlight'

/**
 * ResultTitle component for displaying the title of a search result.
 *
 * @see {@link https://github.com/aws-samples/aws-kendra-transcribe-media-search/blob/main/finderapp/src/search/resultsPanel/components/ResultTitle.tsx ResultTitle - AWS Kendra Transcribe Media Search}
 * @see {@link https://github.com/elangovana/kendra-ui-sample/blob/master/src/search/resultsPanel/components/ResultTitle.tsx ResultTitle - Elango Vana}
 * @example
 * const queryResultItem = { ... }
 * return <ResultTitle queryResultItem={queryResultItem} />
 *
 * @param {Object} props - The component props.
 * @param {Object} props.queryResultItem - The query result item containing the title and URI.
 * @returns {JSX.Element|null} The rendered ResultTitle component or null if no title or URI is available.
 */
const ResultTitle = ({ queryResultItem }) => {
  // title is not guaranteed to exist, show nothing if that's the case
  let resultTitle = null
  if (
    queryResultItem.DocumentTitle &&
    !_.isEmpty(queryResultItem.DocumentTitle.Text)
  ) {
    resultTitle = (
      <TextHighlights textWithHighlights={queryResultItem.DocumentTitle} />
    )
  } else if (queryResultItem.DocumentURI) {
    resultTitle = queryResultItem.DocumentURI
  } else {
    return null
  }

  const uri = queryResultItem.DocumentURI
  if (
    uri &&
    !_.isEmpty(queryResultItem.DocumentTitle.Text) &&
    queryResultItem.DocumentAttributes[0].Key === 'model'
  ) {
    // will need to generate url from result item, right now missing: device name, content type values.
    resultTitle = (
      <Link
        to={`/faqs/${slugify(queryResultItem.DocumentTitle.Text)}?device=${
          queryResultItem.DocumentURI.split('/')[1]
        }`}
        onClick={() => {}}
      >
        {resultTitle}
      </Link>
    )
  }

  return (
    <h2>
      <div className="title">{resultTitle}</div>
    </h2>
  )
}

export default ResultTitle
